import { Component, OnInit, Type, ViewChild } from "@angular/core";
import { CommonHelper } from "../../../shared/helpers/CommonHelper";
import { DropDownList } from "../../../models/DropDownList.model";
import { Json2csvService } from "../../../services/json2csv.service";
import { ToastsManager } from "ng2-toastr";
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectCostService } from '../../../services/project-cost.service';
import { UtilsProjectCost } from '../utils';
import { ErrorHandlerProvider } from '../../../shared/providers/errorHandler.provider';

@Component({
    selector: "app-project-cost-edit",
    templateUrl: "./project-cost-edit.component.html",
    styleUrls: ["./project-cost-edit.component.css"],
})
export class ProjectsCostEditComponent implements OnInit {
    loading: boolean;
    commonHelper: CommonHelper = new CommonHelper();
    dropDownListMonths: DropDownList[] = new Array<DropDownList>();
    dropDownMonthsSettings = {};
    months: Array<any> = [];
    projection: any;
    consultantsProject: Array<any> = [];

    constructor(
        private toastr: ToastsManager,
        private json2csvService: Json2csvService,
        private route: ActivatedRoute,
        private projectCostService: ProjectCostService,
        private router: Router,
        private utilsProjectCost: UtilsProjectCost,
        private errorHandler: ErrorHandlerProvider
    ) { }

    async ngOnInit() {
        this.loading = true;
        this.projection = await this.projectCostService.getById(this.route.snapshot.params['id']);

        this.months = this.utilsProjectCost.multiSelectMonthsAndYearsInit();
        this.dropDownMonthsSettings = this.commonHelper.getDropDownSettings(false, "Meses", true, "Marcar todos os meses", "Desmarcar todos os meses", true, null, "");
        this.dropDownListMonths = this.commonHelper.getDropDownListItems(this.months, "_id", "name");

        this.projection.consultants.forEach(consultant => {
            let projectionDate = [];
            consultant.competences.forEach(date => {
                let newDate = this.months.filter(m => m._id == `${date.month}/${date.year}`);
                projectionDate.push({id: newDate[0]._id, itemName: newDate[0].name});
            });
            this.consultantsProject.push({...consultant, competences: projectionDate });
        });
        this.loading = false;
    }

    async export() {
        if(this.validateValues()) {
            this.calculate();
            this.projection = {
                ...this.projection,
                consultants: this.consultantsProject
            };
            let newCSV = [];
            this.projection.consultants.map((consultant) => {
                consultant.competences.map(date => {
                    newCSV.push({
                        "Consultores":          consultant.name ? consultant.name : '-',
                        "Tipo de Contrato":     consultant.kind ? this.commonHelper.transcriptContractType(consultant.kind) : '-',
                        "Honorario":            consultant.honorarium ? this.commonHelper.transcriptHonorariumType(consultant.honorarium) : '-',
                        "Cliente":              this.projection.customer ? this.projection.customer.name : '',
                        "Grupo de Empresa":     this.projection.companyGroup ? this.projection.companyGroup.name : '-',
                        "Projeto":              this.projection.project ? this.projection.project.name : '-',
                        "Tipos de Serviços":    this.projection.project.subDivision ? this.projection.project.subDivision.name : '-',
                        "Horas Estimadas":      consultant.estimatedHours ? consultant.estimatedHours : '-',
                        "Valor Total Hora":     consultant.hourValue ? Number(consultant.hourValue).toLocaleString("pt-BR",{maximumSignificantDigits : 4}) : '-',
                        "Competência":          date ? date.itemName.slice(0, -5) : ' - ',
                        "Ano":                  date ? date.itemName.slice(-4) : ' - ',
                        "Projeção de Custos":   consultant.projectCost ? Number(consultant.projectCost).toLocaleString("pt-BR",{maximumSignificantDigits : 6}) : '-',
                    });
                });
            });
            this.json2csvService.export(newCSV, `Projeção ${this.projection.project ? this.projection.project.name  : "" } - ${new Date().toLocaleDateString('pt-br')}`);
        } else {
            this.toastr.warning(
                `Preencha os campos Horas Estimadas e Competência em Meses para gerar uma Projeção de Custo.`,
                "FORMULÁRIO INVÁLIDO"
            );
        }
    }

    async salve() {
        if(this.validateValues()) {
            this.calculate();
            this.corrigirDate();
            let newTotal = this.somaTotal();
            this.projection = {
                ...this.projection,
                consultants: this.consultantsProject,
                totalValue: newTotal
            };

            try{
                let res = await this.projectCostService.putProjectionCost(this.projection);
                if(res._id) {
                    this.loading = true;
                    this.toastr.success('Projeção atualizada com sucesso!');
                    this.router.navigate(['/projects-cost']);
                    this.loading = false;
                } else {
                    this.errorHandler.interceptError(res, 'Projeção de custo');
                }
            } catch(err) {
                this.errorHandler.interceptError(err, 'Projeção de custo');
            }
        } else {
            this.toastr.warning(
                `Preencha os campos Horas Estimadas e Competência em Meses para gerar uma Projeção de Custo.`,
                "FORMULÁRIO INVÁLIDO"
            );
        }
    }

    calculate() {
        this.consultantsProject = this.consultantsProject.map(consultant => {
            let projectCost = consultant.estimatedHours * consultant.hourValue;
            return { ...consultant, projectCost: projectCost.toFixed(2) };
        })
    }

    corrigirDate() {
        this.consultantsProject = this.consultantsProject.map(consultant => {
            let newCompetences = [];
            consultant.competences.map(date => newCompetences.push({
                month: Number(date.id.slice(0, -5)),
                year: Number(date.id.slice(-4))
            }));
            return { ...consultant, competences: newCompetences };
        });
    }

    somaTotal() {
        let cost = 0;
        this.consultantsProject.map((consultant) =>  cost += Number(consultant.projectCost));
        return cost;
    }

    validateValues() {
        let validate = this.consultantsProject.map(consultant => {
            if(consultant.estimatedHours && consultant.competences.length > 0) return true;
                else return false;
        });

        if(validate.find(valid => valid == false) === undefined) return true;
            else return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/views/project-cost/project-cost-edit/project-cost-edit.component.ts